import api from '@/services/api'

export default () => new Promise((resolve, reject) => api()({
    url: 'catalog/getProductGroupNames'
}).then(e => {
    return resolve(e.data.data)
}).catch(f => reject(false)))